import React from "react";
import { Link, Links } from "react-router-dom";
import bikeImg from '../../../assets/images/image/bike/1.jpg'
const Comparisons = () => {
  return (
    <>
      <section className="counter-compare" >
        <div className="compare-background-overlay"></div>
        <div className="container">
          <div className="text-white text-center position-relative" style={{ zIndex: '2' }}>
            <h3 className="fw-bold">Compare Products Easily</h3>
            <p className="text-xl text-gray-200 mb-2">
              Make smarter choices with side-by-side product insights tailored just for you.
            </p>
            <p className="text-xl text-gray-200 mb-2">
              Forget endless tabs — compare top options in one smooth experience.
            </p>
            <p className="text-xl text-gray-200 mb-8">
              Explore features, pricing, and real reviews — all in one place.
            </p>
            <Link to='/comparison'>
            <button
              className="btn btn-danger mt-4"
            >
              Start Comparing
            </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Comparisons;
